import { render, staticRenderFns } from "./AssetsTable.vue?vue&type=template&id=3b8b90cb&"
import script from "./AssetsTable.vue?vue&type=script&lang=ts&"
export * from "./AssetsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports